import type { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";

import type { EventPrefix } from "@/features/analytics/models";
import {
  CUSTOMER_IO_EVENT,
  EVENT_PREFIX,
  GOOGLE_TAG_MANAGER_EVENT,
} from "@/features/analytics/models";
import { triggerGoogleTagManagerTracking } from "@/features/analytics/triggers";

interface TrackNamePageViewedParams {
  customerIoAnalytics: AnalyticsBrowser;
  eventPrefix?: EventPrefix;
}

export const trackNamePageViewed = ({
  customerIoAnalytics,
  eventPrefix = EVENT_PREFIX.NONE,
}: TrackNamePageViewedParams) => {
  triggerGoogleTagManagerTracking({
    event: `${eventPrefix}${GOOGLE_TAG_MANAGER_EVENT.NAME_PAGE_VIEWED}`,
  });
  void customerIoAnalytics.track(
    `${eventPrefix}${CUSTOMER_IO_EVENT.NAME_PAGE_VIEWED}`,
    {
      source: window.location.href,
    },
  );
};
